var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeSquareOneCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41760",
    "data-name": "Group 41760",
    transform: "translate(-857 -17215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15754",
    "data-name": "Rectangle 15754",
    width: 16,
    height: 16,
    transform: "translate(857 17215)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "categories",
    d: "M13.16,8.12v3.92a1.12,1.12,0,0,1-1.12,1.12H8.12A1.12,1.12,0,0,1,7,12.04V8.12A1.12,1.12,0,0,1,8.12,7h3.92A1.12,1.12,0,0,1,13.16,8.12ZM19.88,7H15.96a1.12,1.12,0,0,0-1.12,1.12v3.92a1.12,1.12,0,0,0,1.12,1.12h3.92A1.12,1.12,0,0,0,21,12.04V8.12A1.12,1.12,0,0,0,19.88,7Zm-7.84,7.84H8.12A1.12,1.12,0,0,0,7,15.96v3.92A1.12,1.12,0,0,0,8.12,21h3.92a1.12,1.12,0,0,0,1.12-1.12V15.96A1.12,1.12,0,0,0,12.04,14.84Zm5.88,0A3.08,3.08,0,1,0,21,17.92a3.08,3.08,0,0,0-3.08-3.08Z",
    transform: "translate(851 17209)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeSquareOneCircle);
export default __webpack_public_path__ + "static/media/three-square-one-circle.416abdb4d934820c006c7633a43acaaa.svg";
export { ForwardRef as ReactComponent };